import { ArnCondition, ArnPredefinedConditionTemplate } from './ArnCondition';
import { ArnConditionOpts } from './ArnConditionOpts';

export interface HasArianeeSmartAssetConditionOpts extends ArnConditionOpts {
  tags?: string[];
}

export class HasArianeeSmartAssetCondition implements ArnCondition {
  readonly templateName = ArnPredefinedConditionTemplate.HasArianeeSmartAsset;

  constructor(public opts: HasArianeeSmartAssetConditionOpts) {}
}
